import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  TextField,
  Button,
  Box,
  Chip
} from '@mui/material'

const AiTemplateArrayInput = ({
  label,
  placeholder,
  items,
  onAdd,
  onRemove,
  required = false
}) => {
  const { t } = useTranslation()
  const [newValue, setNewValue] = useState('')

  const handleAdd = () => {
    if (newValue.trim()) {
      onAdd(newValue.trim())
      setNewValue('')
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd()
    }
  }

  return (
    <Box>
      <TextField
        fullWidth
        size="small"
        label={required ? `${label} *` : label}
        placeholder={placeholder}
        value={newValue}
        onChange={(e) => setNewValue(e.target.value)}
        onKeyDown={handleKeyPress}
        InputProps={{
          endAdornment: (
            <Button
              onClick={handleAdd}
              disabled={!newValue.trim()}
              size="small"
            >
              {t('mailTemplate.wizard.ai.add')}
            </Button>
          )
        }}
        sx={{
          mb: 1,
          '& .MuiInputBase-root': {
            height: 40
          }
        }}
      />
      <Box display="flex" flexWrap="wrap" gap={0.5}>
        {items.map((item, index) => (
          <Chip
            key={item.id || `${index}-${item.value || String(item)}`}
            label={item.value || String(item)}
            onDelete={() => onRemove(index)}
            size="small"
          />
        ))}
      </Box>
    </Box>
  )
}

export default AiTemplateArrayInput
